import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'uvilo-ai', {
    // ** Confirm dialog defaults
    confirmOk: 'OK',
    confirmCancel: 'Cancel',

    // ** App bar
    applyNow: 'Apply Now',
    logIn: 'Log in',

    // ** Landing hero (alpha)
    heroChip: 'Built on timeless wisdom • Powered by AI',
    heroTitleLine1: 'The World’s',
    heroTitleLine2: 'First Personal',
    heroTitleLine3: 'Success Platform',
    heroSubtitle:
      'Harness ancient philosophy and modern science to build a life of meaning, resilience, and harmony across all domains of life.',
    heroCtaStart: 'Start Your Journey',

    // ** Problem section
    problemOverline: 'Why balance feels impossible',
    problemTitle: 'Modern life pulls in 11 directions at once.',
    problemBody:
      'Burnout, financial stress, and endless distraction fragment attention and erode well‑being. A checklist won’t fix that. You need a system that considers the whole person—and adapts as life changes.',

    // ** How it works section
    howOverline: 'How it works',
    howTitleLine1: 'Ancient wisdom.',
    howTitleLine2: 'Modern intelligence.',
    howBody:
      'Uvilo blends philosophy and psychology with adaptive AI to guide practical action. It’s not a brochure; it’s an invitation to engage and activate.',
    howCtaBegin: 'Begin Self‑Assessment',
    howCtaExplore: 'Explore benefits',

    // ** Benefits section
    benefitsTitle: 'What you gain with Uvilo',

    // ** Proof section
    proofOverline: 'Why people choose Uvilo',
    proofTitle: 'Proof you can feel quickly',
    proofBody:
      'Demos, quick wins, and testimonials help you see and feel progress fast. Try it for a week—notice the shift.',
    proofHighlight1: 'Clarity in priorities',
    proofHighlight2: 'Less friction in routines',
    proofHighlight3: 'Measurable mood lift',

    // ** Call to action section
    ctaTitle: 'Begin Your Self‑Assessment',
    ctaBody:
      'Five minutes to map your current balance and meet your first AI guide. Your data is private and encrypted.',
    ctaStartFree: 'Start Free',
    ctaPrivacy: 'Privacy & Security',

    // ** Footer
    footerBrand: 'Uvilo AI',
    footerTagline: 'Balance as a practice, not a destination.',
    footerRights: 'Uvilo, Inc. All rights reserved.',

    // ** Coming soon landing (index)
    comingSoonChip: 'Uvilo: Coming Soon',
    betaTitleJoin: 'Join',
    betaTitleTheUvilo: 'the Uvilo',
    betaTitlePrivateBeta: 'Private Beta',
    betaSubtitle:
      'Your opinion matters. Make your voice heard. Become one of our Founding Builders and shape the future of personal success.',
    comingSoonTagline: "The world's first personal success platform.",
    footerContact: 'Contact us at info@uvilo.com',
  });
}
